"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var TableRowTd = (0, _styledBase["default"])("td", {
  target: "exlvl490",
  label: "TableRowTd"
})(process.env.NODE_ENV === "production" ? {
  name: "rq9gny",
  styles: "padding:8px;font-size:14px;font-weight:600;line-height:1.71;border-bottom:1px solid #cccccc;"
} : {
  name: "rq9gny",
  styles: "padding:8px;font-size:14px;font-weight:600;line-height:1.71;border-bottom:1px solid #cccccc;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL3RhYmxlLWNvbHVtbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHNEIiLCJmaWxlIjoiLi4vLi4vc3JjL2NvbXBvbmVudHMvdGFibGUtY29sdW1uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tIFwiQGVtb3Rpb24vc3R5bGVkXCI7XHJcbmltcG9ydCBSZWFjdCBmcm9tIFwicmVhY3RcIjtcclxuXHJcbmNvbnN0IFRhYmxlUm93VGQgPSBzdHlsZWQudGRgXHJcbiAgcGFkZGluZzogOHB4O1xyXG4gIGZvbnQtc2l6ZTogMTRweDtcclxuICBmb250LXdlaWdodDogNjAwO1xyXG4gIGxpbmUtaGVpZ2h0OiAxLjcxO1xyXG4gIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAjY2NjY2NjO1xyXG5gO1xyXG5cclxuZnVuY3Rpb24gVGFibGVDb2x1bW4oeyBjaGlsZHJlbiwgLi4ub3RoZXIgfSkge1xyXG4gIHJldHVybiA8VGFibGVSb3dUZCB7Li4ub3RoZXJ9PntjaGlsZHJlbn08L1RhYmxlUm93VGQ+O1xyXG59XHJcblxyXG5leHBvcnQgZGVmYXVsdCBUYWJsZUNvbHVtbjtcclxuIl19 */"
});

function TableColumn(_ref) {
  var children = _ref.children,
      other = _objectWithoutProperties(_ref, ["children"]);

  return _react["default"].createElement(TableRowTd, other, children);
}

var _default = TableColumn;
exports["default"] = _default;